import React from "react";
import { Container } from "../components/styled.ts";
import { Typography } from "../components/typography/index.tsx";
import { Header } from "../components/header/index.tsx";
import { Seo } from "../components/seo/index.tsx";
import { useMobile } from "../hooks/isMobile.tsx";
import { Tick } from "../components/icons/index.tsx";

const AboutUs = () => {
    const { isMobile } = useMobile();
    return (
        <>
            <Seo
                title="About Us | FinQ India"
                description="FinQ India is built by Konsri Technologies to deliver real-time, AI-powered stock alerts for NSE & BSE via WhatsApp. Learn who we are and what we do."
                path="/about-us"
            />
            <Header />
            <Container
                width="min(calc(100% - 40px) , 900px)"
                justifyContent="center"
                margin="20px auto"
                column
                gap={"20px"}
            >
                <Typography
                    tag="h1"
                    fontFamily="Neue Montreal"
                    fontSize={"28px"}
                    fontWeight={500}
                    lineHeight={"36.4px"}
                    letterSpacing={"0.02em"}
                    color="#202020"
                >
                    About Us — FinQ India
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    At FinQ India, we cut through the noise and bring you what truly
                    matters—real-time, AI-powered stock alerts delivered instantly on
                    WhatsApp. Trusted by thousands of investors and traders across the
                    country, our mission is simple: empower you with timely, accurate,
                    and actionable market updates so you never miss a critical
                    opportunity.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={500}
                    lineHeight={"36.4px"}
                    letterSpacing={"0.02em"}
                    color="#202020"
                >
                    Who We Are
                </Typography>
                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    FinQ India is a product of Konsri Technologies, a forward-thinking
                    tech company dedicated to building innovative, user-centric digital
                    solutions. With this strong technological foundation.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={500}
                    lineHeight={"36.4px"}
                    letterSpacing={"0.02em"}
                    color="#202020"
                >
                    What We Do
                </Typography>
                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    FinQ India helps you stay ahead in the market by delivering
                    lightning-fast updates tailored to your preferred stocks. From
                    corporate announcements to market-moving events, our AI-driven
                    alert system ensures you receive real-time insights—right where
                    you’re most active: on WhatsApp.
                </Typography>

                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={500}
                    lineHeight={"36.4px"}
                    letterSpacing={"0.02em"}
                    color="#202020"
                >
                    We provide:
                </Typography>
                <Container gap="5px">
                    <Container
                        width="20px"
                        height="20px"
                        alignItems="center"
                        padding="1px 3px"
                        radius="10px"
                        background="linear-gradient(165.56deg, #5395FF 39.75%, #D69DFF 58.69%)"
                    >
                        <Tick color="#fff" width="15" height="15" />
                    </Container>
                    <Typography
                        tag="p"
                        fontFamily="Neue Montreal"
                        fontSize={"16px"}
                        fontWeight={500}
                        lineHeight={"20.8px"}
                        letterSpacing={"0.02em"}
                        color="#202020"
                    >
                        AI-Powered Real-Time Alerts
                    </Typography>
                </Container>
                <Container gap="5px">
                    <Container
                        width="20px"
                        height="20px"
                        alignItems="center"
                        padding="1px 3px"
                        radius="10px"
                        background="linear-gradient(165.56deg, #5395FF 39.75%, #D69DFF 58.69%)"
                    >
                        <Tick color="#fff" width="15" height="15" />
                    </Container>
                    <Typography
                        tag="p"
                        fontFamily="Neue Montreal"
                        fontSize={"16px"}
                        fontWeight={500}
                        lineHeight={"20.8px"}
                        letterSpacing={"0.02em"}
                        color="#202020"
                    >
                        Coverage Across 7000+ BSE Stocks
                    </Typography>
                </Container>
                <Container gap="5px">
                    <Container
                        width="20px"
                        height="20px"
                        alignItems="center"
                        padding="1px 3px"
                        radius="10px"
                        background="linear-gradient(165.56deg, #5395FF 39.75%, #D69DFF 58.69%)"
                    >
                        <Tick color="#fff" width="15" height="15" />
                    </Container>
                    <Typography
                        tag="p"
                        fontFamily="Neue Montreal"
                        fontSize={"16px"}
                        fontWeight={500}
                        lineHeight={"20.8px"}
                        letterSpacing={"0.02em"}
                        color="#202020"
                    >
                        Includes BSE SME stocks
                    </Typography>
                </Container>
                <Container gap="5px">
                    <Container
                        width="20px"
                        height="20px"
                        alignItems="center"
                        padding="1px 3px"
                        radius="10px"
                        background="linear-gradient(165.56deg, #5395FF 39.75%, #D69DFF 58.69%)"
                    >
                        <Tick color="#fff" width="15" height="15" />
                    </Container>
                    <Typography
                        tag="p"
                        fontFamily="Neue Montreal"
                        fontSize={"16px"}
                        fontWeight={500}
                        lineHeight={"20.8px"}
                        letterSpacing={"0.02em"}
                        color="#202020"
                    >
                        Smarter Investment Decisions
                    </Typography>
                </Container>
                <Typography
                    tag="p"
                    fontFamily="Neue Montreal"
                    fontSize={"18px"}
                    fontWeight={400}
                    lineHeight={"27px"}
                    letterSpacing={"0.02em"}
                    color="#828282"
                >
                    Stay ahead with timely stock alerts. Join FinQ India today.
                </Typography>

                <Container
                    margin="40px 0 20px 0"
                    padding="24px"
                    border="1px solid #E0E0E0"
                    radius="12px"
                    column
                    gap="16px"
                >
                    <Typography
                        tag="p"
                        fontFamily="Neue Montreal"
                        fontSize={"18px"}
                        fontWeight={500}
                        lineHeight={"36.4px"}
                        letterSpacing={"0.02em"}
                        color="#202020"
                    >
                        Registered Address
                    </Typography>
                    <Typography
                        tag="p"
                        fontFamily="Neue Montreal"
                        fontSize={"16px"}
                        fontWeight={400}
                        lineHeight={"24px"}
                        letterSpacing={"0.02em"}
                        color="#828282"
                    >
                        KONSRI TECHNOLOGIES PRIVATE LIMITED
                    </Typography>
                    <Typography
                        tag="p"
                        fontFamily="Neue Montreal"
                        fontSize={"16px"}
                        fontWeight={400}
                        lineHeight={"24px"}
                        letterSpacing={"0.02em"}
                        color="#828282"
                    >
                        Plot No 164, KVR HIRISE PARADISE, Bachupally, Hyderabad, Telangana, India, 500090
                    </Typography>
                    <Typography
                        tag="p"
                        fontFamily="Neue Montreal"
                        fontSize={"16px"}
                        fontWeight={400}
                        lineHeight={"24px"}
                        letterSpacing={"0.02em"}
                        color="#828282"
                    >
                        CIN: U63999TS2024PTC188525
                    </Typography>
                </Container>
            </Container>
        </>
    );
};

export default AboutUs;
